import {addCollection} from '@iconify/vue2';
import mdi from '@iconify-json/mdi/icons.json';

/**
 * Offline Iconify sets (same approach as iqAgent) — no CDN.
 */
export function setupIconifyOffline() {
    addCollection(mdi);
}
